<template>
  <div>
    <wc-page-title :loading='showLoadingBar' :title='title' :subtitle='subtitle'>
      <template v-slot:appendSubtitle>
        <v-tooltip v-if='project.is_comm' top open-delay='500'>
          <template v-slot:activator='{ on }'>
            <v-icon
              v-if='project.is_comm'
              v-on='on'
              class="ml-2"
              style='vertical-align: baseline; transform: translateY(2px);'
              :large='$vuetify.breakpoint.mdAndUp'
              color='primary'
            >
              mdi-domain
            </v-icon>
          </template>
          Commercial Project
        </v-tooltip>
        <v-tooltip v-if='!project.is_comm' top open-delay='500'>
          <template v-slot:activator='{ on }'>
            <v-icon
              v-if='!project.is_comm'
              v-on='on'
              class="ml-2"
              style='vertical-align: baseline; transform: translateY(2px);'
              :large='$vuetify.breakpoint.mdAndUp'
              color='info'
            >
              mdi-home-outline
            </v-icon>
          </template>
          Residential Project
        </v-tooltip>
        <wc-is-capital-install
          class="ml-2"
          style='vertical-align: text-bottom;'
          v-if='project.project_detail && !project.project_detail.is_capital_system'
        ></wc-is-capital-install>
      </template>
      
      <template v-slot:rightSide v-if='project.division_obj && project.division_obj.division === "Irrigation"'>
        <wc-burger-menu>
          <v-list-item :disabled='alreadyNewHomeowner || project.archived' @click='showConfirmNewHomeowner = true'>
            <v-list-item-icon>
              <v-icon color='info'>mdi-account-convert</v-icon>
            </v-list-item-icon>
            <v-list-item-title>New Homeowner</v-list-item-title>
          </v-list-item>

          <v-list-item v-if='!project.owner' @click='openNewHomeownerLetter' :disabled='project.archived'>
            <v-list-item-icon>
              <v-icon color='info'>mdi-printer</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Print New Homeowner Letter</v-list-item-title>
          </v-list-item>

          <v-list-item @click='toggleHold' :disabled='project.archived'>
            <v-list-item-icon>
              <v-icon :color='project.on_hold ? "success" : "error"'>{{project.on_hold ? $icons.remove_hold.icon : $icons.hold.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ project.on_hold ? "Remove Project Hold" : "Put Project on hold"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

           <v-list-item @click='toggleArchive'>
            <v-list-item-icon>
              <v-icon :color='project.archived ? "success" : "error"'>{{ project.archived ? "mdi-archive-arrow-up" : "mdi-archive" }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ project.archived ? "Un-archive Project" : "Archive Project"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
      
    </wc-page-title>

    <v-container v-if='project && project.on_hold' class='mb-n6'>
      <v-alert border='bottom' type='error' :icon='$icons.hold.icon'>
        This Project has been placed on hold<br>
        <span class='font-italic caption'>
          Don't forget to place open work orders on hold as well. (you can also add a reason for this hold by editing the action tracker that was created).
        </span>
      </v-alert>
    </v-container>
    <v-container v-if='project && project.archived' class='mb-n6'>
      <v-alert border='bottom' type='error'>
        This Project is archived. <br>
        <span class='font-italic caption'>
          Don't forget to zero out any invoices and archive them (as well as archiving any open work orders)
        </span>
      </v-alert>
    </v-container>

    <wc-confirm
      v-if='project.project_detail'
      :showDialog='showConfirmNewHomeowner'
      @cancel='showConfirmNewHomeowner = false'
      @confirm='setNewHomeowner'
      :loading='showLoadingBar'
      saveText="Yes, I know what I'm doing"
      width='900'
    >
      Switch this project to "New Homeowner"?<br>
      <br>
      This will remove <strong>all</strong> contacts from the project, reset authorizations, and set the project name to "New Homeowner".<br>
      This should only done if the existing owner has moved and you need to determine who the new homeowner is.
      <br><br>
      <strong>If staging has already begun, be sure to set the project back to ready for notice 1.</strong><br><br>
      Please double check these note to be sure they apply to the project and not the old homeowner -<br><br>
      <b>SU Client:</b> {{ this.project.project_detail.su_instr_perm_client ? this.project.project_detail.su_instr_perm_client : " None..." }}<br>
      <b>SU Field:</b> {{ this.project.project_detail.su_instr_perm_field ? this.project.project_detail.su_instr_perm_field : " None..." }}<br>
      <b>SU Office:</b> {{ this.project.project_detail.su_instr_perm_office ? this.project.project_detail.su_instr_perm_office : " None..." }}<br>
      <b>BD Client:</b> {{ this.project.project_detail.bd_instr_perm_client ? this.project.project_detail.bd_instr_perm_client : " None..." }}<br>
      <b>BD Field:</b> {{ this.project.project_detail.bd_instr_perm_field ? this.project.project_detail.bd_instr_perm_field : " None..." }}<br>
      <b>BD Office:</b> {{ this.project.project_detail.bd_instr_perm_office ? this.project.project_detail.bd_instr_perm_office : " None..." }}<br><br>

      <strong>Be sure to edit these notes if changes are needed.</strong><br><br> 
    </wc-confirm>

    <wc-confirm
      :showDialog='markNewHomeownerLetterSent'
      @cancel='markNewHomeownerLetterSent = false'
      @confirm='recordNewHomeownerLetterSent'
      title='Record Letter as Sent?'
      width='500'
      saveText='Yes, record as mailed'
      cancelText='No, do not record as mailed'
    >
      Do you want to record in the Action Tracker that you have printed<br><strong><u>and mailed</u></strong> the new homeowner letter?
    </wc-confirm>

    <wc-dialog
      :showDialog='showConflictsDialog'
      :title='"Conflicts for - " + project.name'
      hideCancel
      @save='showConflictsDialog = false'
      saveText='Close'
    >
      <template v-if='project && project.analytics && project.analytics.conflicts && project.analytics.conflicts.length'>
        <template v-for='(conflict, index) in project.analytics.conflicts'>
          <div :class='conflict.can_ignore === false ? "error--text font-weight-bold" : "warning--text"' :key='index'>
            {{conflict.value + " - " + conflict.text}}
          </div>
        </template>
      </template>
      <v-card-text v-else class='success--text'>No conflicts found</v-card-text>
    </wc-dialog>

    <router-view
      v-if='!isLoading'
      :project='project'
      @update='update'
      @updateSpecial='updateSpecial'
    ></router-view>
  </div>
</template>

<script>
import trackerAPI from '@/api/tracker';
import irrigationsAPI from '@/modules/irrigation/api/irrigations';
import projectsAPI from '@/modules/projects/api/projects';
import stagingProjectsAPI from "@/api/staging";
import WCIsCapitalInstall from '@/components/chips/WCIsCapitalInstall';
import _ from 'lodash';
import moment from 'moment';
import { mapState } from 'vuex';
import endpoints from '@/api/endpoints';
export default {
  name: 'irrigation-detail-base',
  data: () => ({
    project: {},
    isLoading: true,
    showLoadingBar: true,
    showConflictsDialog: false,
    showConfirmNewHomeowner: false,
    markNewHomeownerLetterSent: false,
  }),
  computed: {
    title () {
      if (this.project) {
        return this.project.name
      }
      return ''
    },
    subtitle () {
      if (this.project) {
        return this.project.site_address
      }
      return ''
    },
    alreadyNewHomeowner () {
      if (this.project && this.project.name.search("New Homeowner") !== -1) {
        return true
      }
      return false
    },
    conflicts() {
      if (_.some(this.project.analytics.conflicts, p => p.can_ignore === false)) {
        return { icon: "mdi-alert-circle" , color: "error", tooltip: "Click to view conflicts (at least one fatal)"}
      } else if (this.project.analytics.conflicts.length) {
        return { icon: "mdi-alert-circle-outline" , color: "warning", tooltip: "Click to view conflicts"}
      } else {
        return { icon: "mdi-check-circle-outline" , color: "success", tooltip: "This project has no conflicts"}
      }
    },
    menu () {
      return [
        {
          title: this.overview.title,
          icon: this.overview.icon,
          route: { name: 'IrrigationOverview', params: { id: this.$route.params.id } }
        },
        {
          title: 'Work Orders',
          icon: this.workorders.icon,
          route: { name: 'WorkOrders', params: { id: this.$route.params.id } }
        },
        {
          title: 'Invoices',
          icon: this.invoices.icon,
          route: { name: 'IrrigationInvoices', params: { id: this.$route.params.id } }
        },
        {
          title: 'Estimates',
          icon: this.estimates.icon,
          route: { name: 'IrrigationEstimates', params: { id: this.$route.params.id } }
        },
        {
          title: 'Timesheet Details',
          icon: this.$store.state.icons.modules.timesheets.icon,
          route: { name: 'IrrigationTimesheetDetails' }
        },
        {
          title: this.actionTracker.title,
          icon: this.actionTracker.icon,
          route: { name: 'IrrigationActionTracker', params: { id: this.$route.params.id } }
        }
      ]
    },
    ...mapState({
      overview: state => state.icons.routes.overview,
      clients: state => state.icons.modules.clients,
      actionTracker: state => state.icons.routes.actionTracker,
      workorders: state => state.icons.modules.workorders,
      invoices: state => state.icons.dataBox.invoices,
      estimates: state => state.icons.modules.estimates
    })
  },
  mounted () {
    this.getIrrigation()
  },
  methods: {
    async getIrrigation () {
      this.project = await projectsAPI.getProject(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', 'Project Menu')
      this.$store.dispatch('loadSubnav', this.menu)
      this.isLoading = false
      this.showLoadingBar = false
    },
    async update (proj) {
      if (proj.length === 0) {
        this.project = await projectsAPI.getProject(this.$route.params.id)
      } else {
        this.showLoadingBar = true;
        await irrigationsAPI.updateIrrigationProject(proj.project_detail)
        this.project = await projectsAPI.updateProject(proj)
        this.showLoadingBar = false
      }
    },
    async updateSpecial (proj) {
      await this.update(proj)
      await irrigationsAPI.updateWONotes(proj.id)
    },
    async setNewHomeowner () {
      this.showLoadingBar = true;
      let tmp = this.project.name;
      this.project.name = 'New Homeowner (formerly ' + tmp + ')'

      if (this.project.owner) {
        this.recordAction('Set project to be New Homeowner. Previous owner was ' + this.project.owner_obj.name_display);
      } else {
        this.recordAction('Set project to be New Homeowner. No previous owner on record.');
      }
      this.project.owner = null
      this.project.bill_to = null
      this.project.install_contact = null
      this.project.sales_contact = null
      this.project.notices_contact = null
      this.project.site_contact = null
      this.project.secondary_site_contact = null
      this.project.service_contact = null
      this.project.secondary_service_contact = null
      this.project.project_detail.no_work_required = false
      this.project.project_detail.su_authorized = false
      this.project.project_detail.bd_authorized = false
      await this.update(this.project)
      stagingProjectsAPI.newHomeowner(this.project.id);
      //TODO
      this.showConfirmNewHomeowner = false
      this.showLoadingBar = false
    },
    openNewHomeownerLetter () {
      const link = document.createElement('a')
      const previewURL = this.$axios.defaults.baseURL + endpoints.newHomeownerLetter + this.project.id
      link.target = '_blank'
      link.href = previewURL
      link.click()
      this.markNewHomeownerLetterSent = true
    },
    recordNewHomeownerLetterSent () {
      this.recordAction('Printed, and mailed, the New Homeowner letter.')
      this.markNewHomeownerLetterSent = false
    },
    async recordAction (description) {
      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'project': this.project.id
      }
      trackerAPI.createProjectTracker(tracker);

      if (this.$route.name === 'IrrigationActionTracker') {
        this.$router.go();
      }
    },
    toggleArchive () {
      // if/when recycle bin implemented - this will be a one way toggle only, and will need a confirm dialog
      this.project.archived = !this.project.archived;
      const description = this.project.archived ? "Project Archived" : "Project has been Un-archived";
      this.recordAction(description);
      this.update(this.project);
    },
    toggleHold () {
      this.project.on_hold = !this.project.on_hold;
      const description = this.project.on_hold ? "Project placed on hold" : "Hold removed from Project";
      this.recordAction(description);
      this.update(this.project);
    }
  },
  components: {
    'wc-is-capital-install': WCIsCapitalInstall
  }
}
</script>
